/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_CharactersInputs */



/**
* | output |
* | --- |
* | "Translation Characters" |
*
* @param {Translation_CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_characters = /** @type {((inputs?: Translation_CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Caractères de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungszeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Personaggi della traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Символы перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Caracteres de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳文字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद वर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Caracteres de tradução")
	return /** @type {LocalizedString} */ ("Translation Characters")
});